module.exports = __webpack_public_path__ + "media/images/users/avatar-10-b54a7a8912110c638b33bc2c93989978.jpg";